__turbopack_context__.v({
  "my_list_viewing_history_grid_item": "MyListViewingHistoryGridItem-module-scss-module__V3ehXG__my_list_viewing_history_grid_item",
  "my_list_viewing_history_kabob_menu": "MyListViewingHistoryGridItem-module-scss-module__V3ehXG__my_list_viewing_history_kabob_menu",
  "my_list_viewing_history_link": "MyListViewingHistoryGridItem-module-scss-module__V3ehXG__my_list_viewing_history_link",
  "my_list_viewing_history_remove_button": "MyListViewingHistoryGridItem-module-scss-module__V3ehXG__my_list_viewing_history_remove_button",
  "my_list_viewing_history_show_link": "MyListViewingHistoryGridItem-module-scss-module__V3ehXG__my_list_viewing_history_show_link",
});
